import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'zeroNumber'
})
export class ZeroNumberPipe implements PipeTransform {

  transform(value: any, args?: any): any {
    if (!!value) {
      if (parseInt(value, 0).toFixed(0) === '0') {
        return '-';
      }
      return value;
    }
    return '-';
  }

}




// WEBPACK FOOTER //
// /opt/alm/jenkins/workspace/mis-cpm/mis-cpm-prod-front/src/app/pipe/zero-number.pipe.ts